export default __webpack_public_path__ + "static/media/download-file-excel-blue.0388d720.svg";